import { useContext } from "react";

import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import ButtonDefault from "components/DesignComponents/ButtonDefault";
import Checkbox from "components/DesignComponents/Checkbox";
import TextLink, {
    TEXT_LINK_SIZES
} from "components/DesignComponents/TextLink";
import TableContext from "context/table/tableContext";
import { TABLE_NAMES, useMediaQueries } from "shared";

import Actions from "./Actions";
import useTableHeadToolbar from "./hooks/useTableHeadToolbar";
import { TableHeadToolbarProps } from "./types";

const TableHeadToolbar = ({ toggleActiveHead }: TableHeadToolbarProps) => {
    const { tableName, deselectAllRows } = useContext(TableContext);

    const { blue300, blue400, blue500, gray900, white } = colors;

    const { t } = useTranslation();
    const { toMd, fromMd } = useMediaQueries();

    const {
        atLeastSingleSelected,
        allSelected,
        rowsCount,
        handleCheckboxChange
    } = useTableHeadToolbar();

    return (
        <div
            css={css({
                display: "flex"
            })}
        >
            <div
                css={css({
                    display: "flex",
                    borderRadius: "8px",
                    columnGap: "1px",
                    background: white,
                    padding: "1px",

                    "& > button": {
                        display: "flex",
                        alignItems: "center",
                        color: gray900,
                        background: blue300,
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "500",
                        letterSpacing: "0.1px",
                        cursor: "pointer",
                        border: "none",
                        outline: "none",
                        transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms"
                    },

                    "& > button:not(:first-of-type)": {
                        padding: "3px 15px 3px 16px"
                    },

                    "& > button:last-of-type": {
                        borderRadius:
                            tableName === TABLE_NAMES.Devices && !toMd
                                ? "8px"
                                : "0 8px 8px 0"
                    },

                    "& > button:hover": {
                        background: blue400,
                        zIndex: "1"
                    },

                    "& > button:active": {
                        background: blue500,
                        zIndex: "1"
                    }
                })}
            >
                <ButtonDefault
                    css={css({
                        borderRadius: "8px 0 0 8px",
                        padding: "3px 16px 3px 7px"
                    })}
                >
                    <Checkbox
                        label={`${t("Button##rows selected", {
                            count: rowsCount
                        })}`}
                        checked={allSelected}
                        indeterminate={!allSelected && atLeastSingleSelected}
                        onChange={handleCheckboxChange}
                    />
                </ButtonDefault>

                <Actions toggleActiveHead={toggleActiveHead} />
            </div>

            {fromMd && (
                <TextLink
                    size={TEXT_LINK_SIZES.Normal}
                    onClick={deselectAllRows}
                    css={css({
                        marginLeft: "16px"
                    })}
                >
                    {t("Button##deselect all")}
                </TextLink>
            )}
        </div>
    );
};

export default TableHeadToolbar;
